import React, { useEffect, useState } from 'react';

import CardDialog from '~/components/CardDialog';
import Button from '~/components/core/Atomic/Buttons/Button';
import ButtonsContainer from '~/components/core/Atomic/Buttons/ButtonsContainer';
import Grid from '~/components/core/Atomic/Grid/Grid';
import CancelButton from '~/components/core/Buttons/CancelButton';
import RadioWithButtonWrapper from '~/components/core/RadioWithButtonWrapper';
import { getEntityIcon } from '~/Utils/ClaimUtils';

import type { CoveredObjectType } from '../types';

interface CoveredObjectTypeSelectorProps {
  open: boolean;
  availableTypes: CoveredObjectType[];
  onTypeSelected: (typeId: string) => void;
  onClose: () => void;
}

const CoveredObjectTypeSelector: React.FC<CoveredObjectTypeSelectorProps> = ({
  open,
  availableTypes,
  onTypeSelected,
  onClose,
}) => {
  const [selectedType, setSelectedType] = useState<string>('');

  // Reset selection when dialog opens
  useEffect(() => {
    if (open) {
      setSelectedType('');
    }
  }, [open]);

  const handleSelect = () => {
    if (selectedType) {
      onTypeSelected(selectedType);
    }
  };

  const handleClose = () => {
    setSelectedType('');
    onClose();
  };

  return (
    <CardDialog
      isDialog
      open={open}
      onClose={handleClose}
      title="Select Covered Object Type"
      maxWidth="sm"
      closeOnBackdropClick={false}
    >
      <div className="min-w-[400px] py-4">
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <div className="flex flex-col gap-2">
              {availableTypes.map((type) => {
                const IconComponent = getEntityIcon(type.icon);
                const icon = IconComponent ? <IconComponent /> : undefined;

                return (
                  <RadioWithButtonWrapper
                    key={type.id}
                    name="covered_object_type"
                    value={type.id}
                    checked={selectedType === type.id}
                    onChange={(value: string) => setSelectedType(value)}
                    text={type.desc}
                    icon={icon}
                    wrapperOverrideStyle={{ width: '100%', justifyContent: 'left' }}
                  />
                );
              })}
            </div>
          </Grid>
          <Grid item xs={12}>
            <ButtonsContainer>
              <CancelButton onClick={handleClose} />
              <Button variant="contained" color="primary" onClick={handleSelect} disabled={!selectedType}>
                Select
              </Button>
            </ButtonsContainer>
          </Grid>
        </Grid>
      </div>
    </CardDialog>
  );
};

export default CoveredObjectTypeSelector;
